import React from 'react'

type AccountAvatarContextValue = {
  accountAvatarUrl: string | null
  setAccountAvatarUrl: (url: string | null) => void
  accountUserId: string | null
}

const noop = () => {}

export const AccountAvatarContext = React.createContext<AccountAvatarContextValue>({
  accountAvatarUrl: null,
  setAccountAvatarUrl: noop,
  accountUserId: null,
})

export const useAccountAvatar = () => React.useContext(AccountAvatarContext)
